<template>
  <div>

    <Modal
      title="Delete Spot Rate"
      :submit="submit"
      submit-label="Delete"
      :submitting="submitting"
    >

      <p>Are you sure you want to delete this spot rate?</p>

    </Modal>

  </div>  
</template>

<script setup lang="ts">

import { ref } from 'vue'

// misc
import NotificationService from '../../../../../services/NotificationService'
import RatesApi, { type SyncSpotRatesRequestItem } from '../../../../../services/api-clients/RatesApi'
import type { SyncSpotRatesRequest } from '../../../../../services/api-clients/RatesApi'
import type { NonEventExceptionItem } from '../types'
// @ts-ignore
import { closeDialog } from 'vue3-promise-dialog'
import { Temporal } from '@js-temporal/polyfill'
import ChannelDefaultRate from '../../../../../models/ChannelDefaultRate'

interface Props {
  item: NonEventExceptionItem
}

const props = defineProps<Props>()

/**
 * Submission
 */

const submitting = ref<boolean>(false)

async function submit() {

  submitting.value = true

  const request: SyncSpotRatesRequest = {spotRates: []}

  props.item.spotRates.forEach(spotRate => {

    if (spotRate.startDate !== spotRate.endDate) {
      console.error(`SR ${spotRate.ID}'s start_date (${spotRate.startDate}) is not the same as its end_date (${spotRate.endDate})`)
      return
    }

    const defaultRate = props.item.defaultRates.find(dr => dr.ID === spotRate.defaultRateID)
    if (!defaultRate) {
      console.warn(`default rate ${spotRate.defaultRateID} not found`)
      return
    }
    if (defaultRate.locationProductID === null) {
      console.warn(`default rate ${spotRate.defaultRateID}'s location_product_id is null`)
      return
    }

    let cdr: any = defaultRate.channelDefaultRates.find(cdr => cdr.channelFacilitiesID === spotRate.channelFacilityID)
    if (!cdr) {
      // If the CDR is in "pending create" status, it won't be included in the CDRs that get included in
      // props.item.defaultRates. Check for that case.
      // Hackish - but given how hairy this part of the app has become, better safe than sorry.
      cdr = ChannelDefaultRate.query().where('defaultRateID', spotRate.defaultRateID).where('channelFacilitiesID', spotRate.channelFacilityID).first()
      if (!cdr) {
        console.warn(`Couldn't find a CDR for DR ${defaultRate.ID} and CF ${spotRate.channelFacilityID}`)
        return
      }
    }

    let spotDate

    try {
      spotDate = Temporal.PlainDate.from(spotRate.startDate)
    } catch (e) {
      console.error("Couldn't parse spot_rates.start_date as ISO 8601")
      console.error(e)
      return
    }

    const item: SyncSpotRatesRequestItem = {
      date: spotDate,
      locationProductId: defaultRate.locationProductID,
      defaultRateId: spotRate.defaultRateID,
      channelDefaultRateId: cdr.ID,
      channelCost: cdr.channelCost,
    }

    request.spotRates.push(item)

  })

  if (!request.spotRates.length) {
    console.error("request.spotRates is empty")
    NotificationService.error("An error occurred")
    submitting.value = false
    return
  }

  RatesApi.syncSpotRates(request)
    .then(() => {
      closeDialog(true)
    })
    .catch(e => {
      console.error(e)
      NotificationService.error("Couldn't delete spot rate!")
    })
    .finally(() => {
      submitting.value = false
    })

}

</script>
